// Supplier entity manifest: card-only. Supplier has no page or surface — it is a CRM Contact shown
// as a card in the tenant app and in both portals, which reuse the same card.
import { ActivityEntityName, Contact, DomainType } from '@jms/model';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

const card: EntityManifestCard<Contact> = {
  component: () => import('./entity.card.renderer/supplier.entity.card.renderer.component').then(module => module.SupplierEntityCardRendererComponent),
  resolution: 'if-needed',
  // A trading-as row is the picked party itself; fetching the account's card would rename it back (WBS-11914)
  isComplete: value => !!((value as { tradingAs?: string | null }).tradingAs || value.mobile || value.phone || value.workPhone || value.email),
  summarize: value => ({ title: value.name ?? 'Not set' }),
};

export const supplierManifest = registerManifest<Contact>({
  entity: ActivityEntityName.Supplier,
  slug: 'supplier',
  presentation: { card },
  domains: {
    [DomainType.ClientPortal]: { presentation: { card } },
    [DomainType.ContractorPortal]: { presentation: { card } },
  },
});
